<nav class="sidebar sidebar-offcanvas" id="sidebar">

  <ul class="nav flex-column sub-menu">
    <li class="nav-item cursor" id="welcome">
      <a class="nav-link" [routerLink]="['/dashboard/welcome']" routerLinkActive="active" #Class="routerLinkActive">
        <!-- <span><img class="menuIcon" src="../../../../assets/images/Vector1_off.png" alt="icon"></span> -->
        <i class="dx-icon-rowfield menu-icon menuIcon"></i>

        <span class="menu-title">Home</span>
      </a>
    </li>

    <span *ngFor="let aclItem of aclTreeList | keyvalue:onCompare">
      <span>
        <li class="nav-item cursor active" *ngIf="getMenuStaticData(aclItem.key).is_active" >
          <a class="nav-link collapsible">
            <i class="dx-icon-fieldchooser menu-icon menuIcon"></i>
            <span class="menu-title">{{getMenuStaticData(aclItem.key).menu_name}}</span>
            <i class="menu-arrow"></i>
          </a>
          <div class="collapse show">
            <ul class="nav flex-column sub-menu">
              <ng-container *ngTemplateOutlet="treeViewList; context:{$implicit: aclItem.value}">
              </ng-container>
              <ng-template #treeViewList let-list>
                <span *ngFor="let item of list">
                  <span *ngIf="item?.hasOwnProperty('children')">
                    <ng-container *ngTemplateOutlet="treeViewListNested; context:{$implicit: item}">
                    </ng-container>
                  </span>
                  <span *ngIf="!item?.hasOwnProperty('children')">
                    <li *ngIf="getMenuStaticData(item.submenu_id).is_active" class="nav-item cursor"
                      [id]="getMenuStaticData(item.submenu_id).routerId">
                      <a class="nav-link" [routerLink]="[getMenuStaticData(item.submenu_id).routerUrl]"
                        routerLinkActive="active" #Class="routerLinkActive" (click)="menuClick(getMenuStaticData(item.submenu_id))">
                        <span><img class="menuIcon" src="../../../../assets/images/Vector-5.png" alt="icon" /></span>
                        <span class="menu-title"> {{item.submenu_name}}</span>
                      </a>
                    </li>
                  </span>
                </span>
              </ng-template>
            </ul>

            <!-- This template is for Nested Menu -->
            <ng-template #treeViewListNested let-list>
              <li class="nav-item cursor active">
                <a class="nav-link collapsible pl-0" style="padding: 0.7rem 1rem !important">
                  <span><img class="menuIcon" src="../../../../assets/images/Vector-5.png" alt="icon" /></span>
                  <span class="menu-title">{{list.submenu_name}}</span>
                  <i class="menu-arrow"></i>
                </a>
                <div class="collapse show" *ngIf="list?.hasOwnProperty('children')">
                  <!-- If any Childen found then call treeViewlist template -->
                  <ul class="nav flex-column sub-menu">
                    <ng-container *ngTemplateOutlet="treeViewList; context:{$implicit: list.children}">
                    </ng-container>
                  </ul>
                </div>
              </li>
            </ng-template>

        </div>
        </li>
      </span>
    </span>

  </ul>
</nav>
